import { motion } from "framer-motion";

const BARS = [
    { h: 92, c: "#3B4A63" },
    { h: 152, c: "#1E40AF" },
    { h: 214, c: "#2563EB" },
    { h: 282, c: "#10B981" },
];

const GrowthBars = ({ className = "" }) => (
    <div className={className} data-testid="growth-bars" aria-hidden="true">
        <svg viewBox="0 0 360 320" fill="none" className="h-auto w-full">
            {BARS.map((bar, i) => (
                <motion.rect
                    key={i}
                    x={42 + i * 72}
                    y={302 - bar.h}
                    width="36"
                    height={bar.h}
                    rx="7"
                    fill={bar.c}
                    initial={{ scaleY: 0 }}
                    animate={{ scaleY: 1 }}
                    style={{ originY: 1 }}
                    transition={{ duration: 1.05, delay: 0.55 + i * 0.18, ease: [0.22, 1, 0.36, 1] }}
                />
            ))}
            <motion.path
                d="M30 284 C 110 268, 190 190, 334 26"
                stroke="#FFFFFF"
                strokeWidth="5"
                strokeLinecap="round"
                initial={{ pathLength: 0 }}
                animate={{ pathLength: 1 }}
                transition={{ duration: 1.5, delay: 1.25, ease: "easeInOut" }}
            />
            <motion.circle
                cx="334"
                cy="26"
                r="7"
                fill="#10B981"
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ duration: 0.4, delay: 2.6 }}
            />
        </svg>
    </div>
);

export default GrowthBars;
